<script setup lang="ts">
import { TaskItemReferenceMeasurementResultsDto } from '@/api/generator';
import MeasurementResults from '@/components/measurement/MeasurementResults.vue';
import MeasurementResultsMeta from '@/components/measurement/MeasurementResultsMeta.vue';

defineProps<{
  result?: TaskItemReferenceMeasurementResultsDto;
}>();
</script>

<template>
  <v-row v-if="result">
    <v-col>
      <h5>{{ $t('Evaluation_one') }}</h5>

      <MeasurementResults :value="result" />

      <div class="text-h6 mt-4 mb-1">
        {{ $t('EnvironmentalConditions') }}
      </div>

      <MeasurementResultsMeta :value="result?.metaData ?? undefined" />
    </v-col>

    <v-col>
      <h5>{{ $t('Note') }}</h5>

      <p class="pre-wrap">
        {{ $t('AbsoluteValuesMsg') }}
      </p>
    </v-col>
  </v-row>
</template>
